<template>
  <v-row>
    <v-col class="fw-bold">
      {{ i18n.global.t('pages.firmwareBulkUpdate.targetDevice.name') }}
      <span style="color: red">✴︎</span>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <v-select
        :label="i18n.global.t('pages.firmwareBulkUpdate.targetDevice.category')"
        v-model="modelValue.category"
        :items="TARGET_CATEGORYS"
        :error-messages="errorMessages['target_category']"
      ></v-select>
    </v-col>
    <v-col>
      <SingleOperationOfficeAutoComplete
        v-if="modelValue.category == TARGET_CATEGORY_OPERATION_OFFICE"
        v-model="selectedOperationOffice"
        :initialOperationId="modelValue?.target?.id"
        :error-messages="errorMessages['target_id']"
        @update:modelValue="targetSelectHandler('operationOffice')"
      />
      <SingleDeviceTypeAutoComplete
        v-else-if="modelValue.category == TARGET_CATEGORY_DEVICE_TYPE"
        v-model="selectedDeviceType"
        :initialItemId="modelValue?.target?.id"
        :error-messages="errorMessages['target_id']"
        @update:modelValue="targetSelectHandler('deviceType')"
      />
      <FirmwareVersionAutoComplete
        v-else-if="modelValue.category == TARGET_CATEGORY_FIRMWARE"
        v-model="firmware"
        :initialItemId="modelValue?.target?.id"
        :error-messages="errorMessages['target_id']"
        @update:modelValue="targetSelectHandler('firmware')"
      />
      <v-select
        v-else
        :label="i18n.global.t('pages.firmwareBulkUpdate.targetDevice.selectCategory')"
        disabled
      ></v-select>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import i18n from '@/lang/i18n';
import FirmwareVersionAutoComplete from '@/components/AutoCompletes/FirmwareVersionAutoComplete.vue';
import SingleDeviceTypeAutoComplete from '@/components/AutoCompletes/SingleDeviceTypeAutoComplete.vue';
import SingleOperationOfficeAutoComplete from '@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue';
import getOperationOffice from '@/types/responses/getOperationOffice';
import FirmwareVersionsType from '@/types/FirmwareVersionsType';
import deviceType from '@/types/DeviceType';
import FirmwareTargetDeviceType from '@/types/FirmwareTargetDeviceType';
import {
  TARGET_CATEGORY_OPERATION_OFFICE,
  TARGET_CATEGORY_DEVICE_TYPE,
  TARGET_CATEGORY_FIRMWARE,
  TARGET_CATEGORYS
} from '@/services/consts/firmware_bulk_update';

const emit = defineEmits(['update:modelValue']);
const props = defineProps<{
  modelValue: FirmwareTargetDeviceType
  errorMessages: {[key:string]: string[]}
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
})

const selectedOperationOffice = ref<getOperationOffice>()
const selectedDeviceType = ref<deviceType>()
const firmware = ref<FirmwareVersionsType>()

function targetSelectHandler(category: string) {
  switch(category) {
    case 'operationOffice':
      modelValue.value = {category: 'operationOffice', target: selectedOperationOffice.value}
      break
    case 'deviceType':
      modelValue.value = {category: 'deviceType', target: selectedDeviceType.value}
      break
    case 'firmware':
      modelValue.value = {category: 'firmware', target: firmware.value}
      break
  }
}
</script>
